
import ExplainerTable from "./explainerTable";
import { formatLatency } from '@circuitry-ai/doc-ui';

const ExplainerDocuments = ({ documentsList, advisor_id, details }: any) => {
    return (
        <div className="flex flex-col gap-3">
            <div className="flex flex-col">
            <div className="flex w-full flex-row items-center justify-between">
                <div className="font-medium text-lg">Context</div>
                {details?.time_taken_retriever && <div className="text-sm"><span className="font-medium">Time Taken:</span> {details?.time_taken_retriever} S</div>}
            </div>
                <div className="text-sm font-normal mt-1">Narrow down the pool of searchable documents by applying filters based on metadata</div>
            </div>
            {details?.retriever_latency !== undefined && details?.retriever_latency !== null && details?.retriever_latency !== '' && (
                <div>
                    <span>Retriever Latency: {formatLatency(details.retriever_latency)} </span>
                </div>
            )}
            <ExplainerTable rowData={documentsList} advisor_id={advisor_id} tab="knowledge"/>
        </div>
    )
}

export default ExplainerDocuments